import React from "react";
import { Box, DialogContent, Typography } from "@mui/material";

const ConfirmationDialog = ({ message, description }) => {
  return (
    <DialogContent>
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: "Montserrat",
            fontWeight: 600,
            mb: 2,
            color: "#333",
          }}
        >
          {message}
        </Typography>
        {description && (
          <Typography
            variant="body1"
            sx={{
              fontFamily: "Montserrat",
              color: "#666",
            }}
          >
            {description}
          </Typography>
        )}
      </Box>
    </DialogContent>
  );
};

export default ConfirmationDialog;

